import React from 'react';
import LOOKUP from 'constants/lookup';
import HighlightOffIcon from '@mui/icons-material/HighlightOff';
import SelectInput from 'screens/components/basic/SelectInput';
import Button from 'screens/components/basic/Button';
import DatePickerInput from 'screens/components/basic/DatePickerInput';
import TextInput from 'screens/components/basic/TextInput';

const safeManagementTypes = [
    { text: "All", value: "0" },
    ...LOOKUP.safemanagement.types
];

const searchFields = (props) => {
    return (
        <div className="row m-0">
            {/*Search Inputs*/}
            <div className="row m-0">
                <div className="col-sm-3">
                    <DatePickerInput name={`${props.pageName}DateFrom`}
                        className="search-field"
                        label={LOOKUP.safemanagement.filters.datefrom.label}
                        floatingLabelText={LOOKUP.safemanagement.filters.datefrom.label}
                        hintText={LOOKUP.safemanagement.filters.datefrom.hintText}
                    />
                </div>
                <div className="col-sm-3">
                    <DatePickerInput name={`${props.pageName}DateTo`}
                        className="search-field"
                        label={LOOKUP.safemanagement.filters.dateto.label}
                        floatingLabelText={LOOKUP.safemanagement.filters.dateto.label}
                        hintText={LOOKUP.safemanagement.filters.dateto.hintText}
                    />
                </div>
                <div className="col-sm-3">
                    <SelectInput
                        name={`${props.pageName}AdjustmentOptions`}
                        className="search-field"
                        label={LOOKUP.safemanagement.filters.type.label}
                        floatingLabelText={LOOKUP.safemanagement.filters.type.label}
                        defaultValue="0"
                        options={safeManagementTypes}
                    />
                </div>
                <div className="col-sm-3">
                    <TextInput
                        name={`${props.pageName}EmployeeName`}
                        className="search-field"
                        label={LOOKUP.safemanagement.filters.employeeName.label}
                        floatingLabelText={LOOKUP.safemanagement.filters.employeeName.label}
                        hintText={LOOKUP.safemanagement.filters.employeeName.hint}
                        fullWidth={true}
                    />
                </div>
            </div>

            {/*Buttons*/}
            <div className="search-buttons row m-0">
                <div className="col-lg-12 pt-2 text-right">
                    <Button
                        type="IconSearchButton"
                        mini={true}
                        label={LOOKUP.cashregister.filters.filterButton}
                        onTouchTap={() => props.search()}
                        className="btnNewBrandPOS"
                    />
                    <Button
                        className="ml-2 btnCleanSearch"
                        type="IconClearButton"
                        label={LOOKUP.cashregister.filters.cleanFilterButton}
                        onTouchTap={() => props.cleanSearch()}
                    />
                    <Button
                        type="DownloadButton"
                        className="pull-right ml-1 btnNewBrandPOS"
                        name={props.pageName + LOOKUP.report.common.downloadReport.name}
                        label={LOOKUP.report.common.downloadReport.label}
                        onTouchTap={() => props.downloadReport()}
                    />
                </div>
            </div>
        </div>
    );
};

export default searchFields;